import React from 'react';
import { SectionShell } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { AUTHOR_IMAGE } from '../../data/content';
export function About() {
  return <SectionShell tone="darker" data-id="element-54" data-mp="12qww6tsi1m37">
      <header className="mb-7 text-center" data-id="element-55" data-mp="12pvmasn7z5n2">
        <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-sky-400" data-id="element-56" data-mp="12osu8he5ux5k">🩺 The author</p>
        <h2 className="font-display text-2xl uppercase leading-tight text-white sm:text-4xl" data-id="element-57" data-mp="ynh3g8jjw5vs">
          About Dr. Karito
        </h2>
      </header>

      <div className="grid items-start gap-6 md:grid-cols-[minmax(0,260px)_1fr]" data-id="element-58" data-mp="61pbtp3m9j0v">
        <figure className="mx-auto w-full max-w-[260px]" data-id="element-59" data-mp="jskpdep28oas">
          <img src={AUTHOR_IMAGE} alt="Dr. Karito, author of the TRT Decision Deck" className="w-full rounded-2xl border border-sky-400/25 object-cover" data-id="element-60" data-mp="ju5kb5fae996" />
          <figcaption className="mt-3 text-center" data-id="element-61" data-mp="3nf1g3g2z7mxi">
            <p className="font-display text-lg uppercase text-white" data-id="element-62" data-mp="3jehlaj5vkvej">Dr. Karito</p>
            <p className="text-xs leading-snug text-sky-100/60" data-id="element-63" data-mp="339rzbsoxivil">
              Author of the TRT Decision Deck™
            </p>
            <p className="mt-1 text-[11px] uppercase tracking-wide text-sky-300/70" data-id="element-64" data-mp="3870fxoufirhq">
              Clinical Practice · Medical Education · Clinical Knowledge Organization
            </p>
          </figcaption>
        </figure>

        <div className="space-y-4 text-sm leading-relaxed text-sky-100/75" data-id="element-65" data-mp="3i07jd45lzxf6">
          <p data-id="element-66" data-mp="2kbnx7i7glwqa">
            For years, Dr. Karito observed a recurring challenge in clinical practice involving TRT:
            the information exists, but it is scattered across guidelines, research papers, clinical
            literature, personal notes, and different resources.
          </p>
          <p data-id="element-67" data-mp="2z8ep76et065v">
            The challenge isn’t always finding more information. Sometimes it’s finding the relevant
            information quickly when a specific clinical scenario is in front of you.
          </p>
          <p className="text-white" data-id="element-68" data-mp="efl13hls2yfn">That’s why Dr. Karito created the TRT Decision Deck™.</p>
          <ul className="space-y-1.5 border-l-2 border-sky-400 pl-4" data-id="element-69" data-mp="2aizjoo5o5rwy">
            <li data-id="element-70" data-mp="25m92fxi4oq9y">Not as another 20-hour course.</li>
            <li data-id="element-71" data-mp="25nkai9ilwk6v">Not as another textbook.</li>
            <li data-id="element-72" data-mp="2jlilr61ms0i5">And not as a replacement for clinical guidelines.</li>
          </ul>
          <p data-id="element-73" data-mp="2fj40ygeeiqo8">
            But as a visual system of decision cards, maps, cases, and reference tools designed to
            help qualified healthcare professionals organize their review process more efficiently.
          </p>
        </div>
      </div>

      <div className="mt-8" data-id="element-74" data-mp="1mwt2bbacuzu2">
        <CTAButton label="Get the TRT Decision Deck™" subline="Instant digital access · $27 one-time" data-id="element-75" data-mp="20md0e3szr8x1" />
      </div>
    </SectionShell>;
}